import { MetricKeyTypeTypeId as MetricKeyTypeTypeId$1, CounterKeyTypeTypeId as CounterKeyTypeTypeId$1, FrequencyKeyTypeTypeId as FrequencyKeyTypeTypeId$1, GaugeKeyTypeTypeId as GaugeKeyTypeTypeId$1, HistogramKeyTypeTypeId as HistogramKeyTypeTypeId$1, SummaryKeyTypeTypeId as SummaryKeyTypeTypeId$1, counter as counter$1, frequency as frequency$1, gauge as gauge$1, histogram as histogram$1, summary as summary$1, isMetricKeyType as isMetricKeyType$1, isCounterKey as isCounterKey$1, isFrequencyKey as isFrequencyKey$1, isGaugeKey as isGaugeKey$1, isHistogramKey as isHistogramKey$1, isSummaryKey as isSummaryKey$1 } from '../../internal/metric/keyType.esm.js';

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
const MetricKeyTypeTypeId = MetricKeyTypeTypeId$1;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category symbols
 */
const CounterKeyTypeTypeId = CounterKeyTypeTypeId$1;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category symbols
 */
const FrequencyKeyTypeTypeId = FrequencyKeyTypeTypeId$1;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category symbols
 */
const GaugeKeyTypeTypeId = GaugeKeyTypeTypeId$1;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category symbols
 */
const HistogramKeyTypeTypeId = HistogramKeyTypeTypeId$1;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category symbols
 */
const SummaryKeyTypeTypeId = SummaryKeyTypeTypeId$1;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category modelz
 */

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category constructors
 */
const counter = counter$1;

/**
 * @since 2.0.0
 * @category constructors
 */
const frequency = frequency$1;

/**
 * @since 2.0.0
 * @category constructors
 */
const gauge = gauge$1;

/**
 * @since 2.0.0
 * @category constructors
 */
const histogram = histogram$1;

/**
 * @since 2.0.0
 * @category constructors
 */
const summary = summary$1;

/**
 * @since 2.0.0
 * @category refinements
 */
const isMetricKeyType = isMetricKeyType$1;

/**
 * @since 2.0.0
 * @category refinements
 */
const isCounterKey = isCounterKey$1;

/**
 * @since 2.0.0
 * @category refinements
 */
const isFrequencyKey = isFrequencyKey$1;

/**
 * @since 2.0.0
 * @category refinements
 */
const isGaugeKey = isGaugeKey$1;

/**
 * @since 2.0.0
 * @category refinements
 */
const isHistogramKey = isHistogramKey$1;

/**
 * @since 2.0.0
 * @category refinements
 */
const isSummaryKey = isSummaryKey$1;

export { CounterKeyTypeTypeId, FrequencyKeyTypeTypeId, GaugeKeyTypeTypeId, HistogramKeyTypeTypeId, MetricKeyTypeTypeId, SummaryKeyTypeTypeId, counter, frequency, gauge, histogram, isCounterKey, isFrequencyKey, isGaugeKey, isHistogramKey, isMetricKeyType, isSummaryKey, summary };
